import { useApp } from '../context.js';
import { Camera, Heart } from '../icons.jsx';
import ProfilePhotoModal from './ProfilePhotoModal.jsx';

export default function ProfilePicker() {
    const { handleProfileSelect, profilePhotos, setShowProfilePhotoUpload, t } = useApp();
    return (
        <div className={`min-h-screen bg-gradient-to-br ${t.bg} flex items-center justify-center p-4 ${t.themeClass}`}>
            <div className="bg-white/90 apple-card rounded-3xl p-8 shadow-xl max-w-sm w-full">
                <div className="text-center mb-8">
                    <div className="flex items-center justify-center gap-2 mb-3">
                        <Heart size={40} className="animate-heartbeat" />
                    </div>
                    <h1 className="text-3xl font-bold text-gray-800 mb-2">Who's here?</h1>
                    <p className="text-sm text-gray-600">Select your profile</p>
                </div>

                <div className="space-y-4">
                    {/* Doug Profile */}
                    <div className="relative">
                        <button
                            onClick={() => handleProfileSelect('doug')}
                            className="w-full bg-gradient-to-br from-blue-400 to-blue-500 text-white px-6 py-5 rounded-2xl font-bold text-xl apple-button shadow-lg hover:shadow-xl flex items-center justify-center gap-4"
                        >
                            {profilePhotos.doug ? (
                                <img src={profilePhotos.doug} alt="Doug" className="w-14 h-14 rounded-full object-cover border-[3px] border-white shadow-md" />
                            ) : (
                                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-blue-400 to-indigo-500 flex items-center justify-center text-2xl font-bold text-white border-[3px] border-white shadow-md">D</div>
                            )}
                            <span>Doug</span>
                        </button>
                        <button
                            onClick={(e) => { e.stopPropagation(); setShowProfilePhotoUpload('doug'); }}
                            className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center text-gray-600 hover:bg-gray-50 apple-button"
                            title="Edit photo"
                        >
                            <Camera size={16} />
                        </button>
                    </div>

                    {/* Les Profile */}
                    <div className="relative">
                        <button
                            onClick={() => handleProfileSelect('les')}
                            className="w-full bg-gradient-to-br from-pink-400 to-pink-500 text-white px-6 py-5 rounded-2xl font-bold text-xl apple-button shadow-lg hover:shadow-xl flex items-center justify-center gap-4"
                        >
                            {profilePhotos.les ? (
                                <img src={profilePhotos.les} alt="Les" className="w-14 h-14 rounded-full object-cover border-[3px] border-white shadow-md" />
                            ) : (
                                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-pink-400 to-rose-500 flex items-center justify-center text-2xl font-bold text-white border-[3px] border-white shadow-md">L</div>
                            )}
                            <span>Les</span>
                        </button>
                        <button
                            onClick={(e) => { e.stopPropagation(); setShowProfilePhotoUpload('les'); }}
                            className="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow-md flex items-center justify-center text-gray-600 hover:bg-gray-50 apple-button"
                            title="Edit photo"
                        >
                            <Camera size={16} />
                        </button>
                    </div>
                </div>

                {/* Profile Photo Upload Modal */}
                <ProfilePhotoModal />
            </div>
        </div>
    );
}
